import React from "react";
import { Container } from "react-bootstrap";
import Row from "react-bootstrap/Row";
import { Col } from "react-bootstrap";
import AgreeServicess from "../../Components/AgreeServicess";
import Enquiry from "../../Components/Enquiry";
import aboutImg from "../../Assets/aboutImg0.webp";
import aboutImg2 from "../../Assets/about2.webp";
import Certificate1 from "../../Assets/certificate1.webp";
import Certificate2 from "../../Assets/certificate2.webp";
import Certificate3 from "../../Assets/certificate3.webp";
import Certificate4 from "../../Assets/certificate4.webp";
import Certificate5 from "../../Assets/certificate5.webp";

function About() {
  return (
    <>
      <Container fluid>
        <Row className="headingimg">
          <Col className="m-5">
            <h1 className="text-white m-4 mx-4 px-2 fw-bold text-center">
              About Us
            </h1>
            <div className="text-white m-4 fw-bold text-center">
              <a href="/" className=" text-white m-3 text-decoration-none">
                Home
              </a>
              <i class="fa-solid fa-circle-arrow-right "></i>
              <a className="text-white text-decoration-none m-3">About Us</a>
            </div>
          </Col>
        </Row>
        <Row>
          <Col lg={6}>
            <h1 className="text-green text-center m-4">Royal Green Energy</h1>
            <p className="m-3 text-justify">
              {" "}
              Established in 2014, Royal Green Energy is an emerging
              manufacturer and supplier of electrical infrastructure materials,
              focused on supporting modern power distribution and utility
              networks across India. We specialize in producing robust
              components used in pole line, tower line, and electrical
              distribution systems, catering to contractors, infrastructure
              developers, and industrial clients.
            </p>
            <p className="m-3 text-justify">
              With a strong emphasis on precision manufacturing and dependable
              production practices, we deliver materials designed for consistent
              performance in demanding field environments. Our operations are
              driven by efficient processes, skilled manpower, and a commitment
              to meeting evolving industry requirements.
            </p>
            <p className="m-3 text-justify">
              Our manufacturing facility is equipped to handle metal
              fabrication, forming, and assembly operations, enabling us to
              supply electrical components in various sizes and specifications.
              From standard hardware to customized requirements, we ensure
              flexibility and consistency in every supply.
            </p>
          </Col>
          <Col lg={6} className="p-3">
            <img
              src={aboutImg}
              alt="hydroponic farming at home"
              className="img-fluid p-3"
            />
          </Col>
        </Row>
        <Row>
          <Col lg={6} className="p-3">
            <img
              src={aboutImg2}
              alt="hydroponic farming cost"
              className="img-fluid p-3"
              style={{
                height: "600px",
                width: "100%",
                objectFit: "cover",
                borderRadius: "8px",
              }}
            />
          </Col>
          <Col lg={6}>
            <p className="m-4 mt-5 text-justify">
              Though newly established, our team brings valuable industry
              experience and technical understanding, allowing us to quickly
              build trust and reliability among our clients. We work closely
              with customers to understand their material needs and ensure
              timely supply across regions.
            </p>
            <p className="m-4 text-justify">Manufacturing Capabilities</p>
            <ul className="m-3 text-justify">
              <li>Electrical pole line and tower line hardware fabrication</li>
              <li>Distribution network fittings and accessories</li>
              <li>Structural metal components for electrical installations</li>
              <li>
                Custom fabrication based on drawings and technical
                specifications
              </li>
              <li>Consistent batch production with controlled processes</li>
            </ul>
          </Col>
        </Row>
        {/* <Row className="m-5">
          <h2 className="text-center text-green">Our Certificates</h2>
          <Col lg={4}>
            <img
              src={Certificate1}
              alt="hydroponic farming in india"
              className="img-fluid p-3"
              style={{ width: "auto", height: "80%" }}
            />
          </Col>
          <Col lg={4}>
            <img
              src={Certificate2}
              alt="hydroponic farming near me"
              className="img-fluid p-3"
              style={{ width: "auto", height: "80%" }}
            />
          </Col>
          <Col lg={4}>
            <img
              src={Certificate3}
              alt="hydroponic farming"
              className="img-fluid p-3"
              style={{ width: "auto", height: "80%" }}
            />
          </Col>
        </Row>
        <Row className="d-flex justify-content-center">
          <Col lg={4}>
            <img
              src={Certificate4}
              alt="hydroponic farm near me"
              className="img-fluid p-3"
              style={{ width: "auto", height: "80%" }}
            />
          </Col>
          <Col lg={4}>
            <img
              src={Certificate5}
              alt="hydroponic farms near me"
              className="img-fluid p-3"
              style={{ width: "auto", height: "80%" }}
            />
          </Col>
        </Row> */}
      </Container>
      <AgreeServicess />
      <Enquiry />
    </>
  );
}

export default About;
